import { createLazyOrchestrator } from 'owa-bundling';
import { openSurfacePrintDialog } from 'owa-calendar-module-commanding';
import { lazyInitPrintDialog } from 'owa-calendar-print';
import { calculateRequestRange } from 'owa-calendar-surface';
import { getSelectedCalendars } from 'owa-calendar-surface-calendars-store';
import { getItemsForAllFolders } from 'owa-calendar-surface-events-lock-store';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { DateRange } from 'owa-datetime-utils';
import loc from 'owa-localize';
import { calendarPrintSettingsMultiCalendarsLabel } from 'owa-locstrings/lib/strings/calendarprintsettingsmulticalendarslabel.locstring.json';
import {
    createLockedCalendarEventsStore,
    EventsCacheLockId,
    CalendarEvent,
} from 'owa-calendar-events-store';

/**
 * Loads items to print and opens print dialog
 */
export const openSurfacePrintDialogOrchestrator = createLazyOrchestrator(
    openSurfacePrintDialog,
    'openSurfacePrintDialog_CLONE',
    async () => {
        // Load all the items for CalendarPrintDialog
        const surfaceStore = getSurfaceStore();
        let requestDateRange: DateRange = calculateRequestRange(
            surfaceStore.selectedDate,
            surfaceStore.dateRange,
            surfaceStore.dateRangeType,
            surfaceStore.userOptions.weekStartDay,
            true /* initial load */
        );
        const selectedCalendars = getSelectedCalendars();
        let calendarId =
            selectedCalendars.length == 1
                ? selectedCalendars[0].displayName
                : loc(calendarPrintSettingsMultiCalendarsLabel);
        // We will be showing a print preview of calendar surface at this point.
        // There are scenarios that we may be fetching more items than current surface store date range
        // Hence creating a unique lock for calendar print scenario.
        let lockForCalendarPrint = createLockedCalendarEventsStore().getLockId();
        let printItems = await fetchItems(requestDateRange, lockForCalendarPrint);
        // Action to open up the CalendarPrint Modal
        (await lazyInitPrintDialog.import())(
            printItems,
            calendarId,
            lockForCalendarPrint,
            surfaceStore.selectedDate,
            requestDateRange,
            surfaceStore.dateRangeType
        );
    }
);

async function fetchItems(
    dateRange: DateRange,
    lockId: EventsCacheLockId
): Promise<CalendarEvent[]> {
    let mergedResult = [];
    const results = await Promise.all<CalendarEvent[]>(getItemsForAllFolders(dateRange, lockId));
    results.forEach(items => items && mergedResult.push(...items));
    return mergedResult;
}
